var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"objects-table"},[_c('e-table-inner',{attrs:{"visibleColumns":_vm.visibleColumns,"itemsEndpoint":_vm.getObjectsEndpoint,"showDeleteButton":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }